// extracted by mini-css-extract-plugin
export var img = "SliderSlide-module--img--3axb0";
export var slide = "SliderSlide-module--slide--2a3wD";